<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="row">
        <div class="col-xs-7">
          <h1>Campaign Sales Active PIN Reports</h1>
        </div>
        <!-- <div class="col-sm-5">
          <a class="btn btn-sm btn-add" href="#" onclick="downloadNow();"
            ><i class="fa fa-download"></i>Download</a
          >
        </div> -->
      </div>
    </section>
    <section class="content">
      <div class="row">
        <!-- <div class="col-xs-6 col-sm-2 form-group">
          <v-select
            v-model="salesReportType"
            :options="[
              { value: '1', text: 'Individual Sale Report' },
              { value: '2', text: 'Sale Summary Report' },
            ]"
            label="text"
            :reduce="(option) => option.value"
            placeholder="--Select--"
            @input="getCampaignSalesReport()"
            class="input-sm"
          >
          </v-select>
        </div> -->
        <!-- <div class="col-xs-6 col-sm-2 form-group">
          <input
            placeholder="From"
            type="text"
            v-model="starttime"
            id="starttime"
            class="form-control input-sm datePicker"
          />
        </div>
        <div class="col-xs-6 col-sm-2 form-group">
          <input
            placeholder="To"
            type="text"
            value=""
            v-model="stoptime"
            id="stoptime"
            class="form-control input-sm datePicker"
          />
        </div> -->
        <div class="col-xs-6 col-sm-2 form-group">
          <v-select
            v-model="salesType"
            :options="[
              { value: '', text: 'Select Type' },
              { value: '1', text: 'Sales' },
              { value: '2', text: 'Return', selected: true },
            ]"
            label="text"
            :reduce="(option) => option.value"
            placeholder="--Select--"
            @input="getCampaignSalesReport()"
            class="input-sm"
          >
          </v-select>
        </div>
        <!-- <div class="col-xs-6 col-sm-2 form-group">
          <input
            placeholder="Search By PIN"
            type="text"
            name="login"
            id="login"
            class="form-control input-sm"
            value=""
          />
        </div> -->
        <div class="col-xs-6 col-sm-2 form-group pull-right">
          <a
            class="btn btn-sm btn-search pull-right"
            id="search"
            href="#"
            @click="getCampaignSalesReport()"
          >
            <i class="fa fa-search"></i> Search
          </a>
        </div>
      </div>
      <div class="row"></div>
      <div class="row">
        <div class="col-md-12">
          <div class="box" id="pagination">
            <div class="box-header">
              <h3 style="display: inline" class="box-title">
                Subscribed PIN Summary
              </h3>
            </div>
            <div class="box-body">
              <div class="table-responsive">
                <table class="table table-0024 table-bordered table-striped">
                  <thead>
                    <tr>
                      <th class="tdCenter tdSN">SN</th>
                      <th class="tdCenter">PIN</th>
                      <th class="tdCenter">Coupon Code</th>
                      <th class="tdCenter">Discount</th>
                      <th class="tdCenter">Login/Return Date</th>
                      <th class="tdCenter">Expiry Date</th>
                      <th class="tdCenter">NOD</th>
                      <th class="tdCenter">Type</th>
                      <th class="tdCenter">Selling Price</th>
                      <th class="tdCenter">Aff Share (%)</th>
                      <th class="tdCenter">Aff Share Amnt</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      :class="pin.type !== 1 ? 'danger' : ''"
                      v-for="(pin, index) in soldPinList"
                    >
                      <td class="tdCenter tdSN">{{ index + 1 }}</td>
                      <td class="tdCenter success">{{ pin.username }}</td>

                      <td class="tdCenter">
                        {{ couponArr[pin.campaign_coupon_id].coupon_code }}
                      </td>
                      <td class="tdCenter">
                        {{
                          couponArr[pin.campaign_coupon_id][
                            pin.rate_plan_detail_id
                          ].discount_type == 1
                            ? "$" +
                              couponArr[pin.campaign_coupon_id][
                                pin.rate_plan_detail_id
                              ].discount_amount
                            : couponArr[pin.campaign_coupon_id][
                                pin.rate_plan_detail_id
                              ].discount_amount + "%"
                        }}
                      </td>
                      <td class="tdCenter">
                        {{ formatDate(pin.creationdate) }}
                      </td>
                      <td class="tdCenter">
                        {{ formatDate(pin.expiry_date) }}
                      </td>
                      <td class="tdCenter">{{ pin.no_of_days }}</td>
                      <td class="tdCenter">
                        <span>
                          <label
                            v-if="pin.type == 1"
                            class="label label-success"
                            >Sale</label
                          >
                          <label v-else class="label label-danger"
                            >Return</label
                          >
                        </span>
                      </td>
                      <td class="tdCenter info">
                        {{ pin.selling_price }}
                      </td>
                      <td class="tdCenter info">
                        {{
                          couponArr[pin.campaign_coupon_id]
                            .affiliate_share_percent
                        }}
                      </td>
                      <td class="tdCenter info">
                        {{
                          pin.type == 1
                            ? (pin.selling_price *
                                couponArr[pin.campaign_coupon_id]
                                  .affiliate_share_percent) /
                              100
                            : 0
                        }}
                      </td>
                    </tr>
                    <tr v-if="soldPinList.length <= 0">
                      <td colspan="16" class="tdCenter" style="padding: 30px 0">
                        <b>No Records Found</b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-middle-small table-bordered">
                <thead>
                  <tr>
                    <th class="tdCenter">Total PIN</th>
                    <th class="tdCenter">Total Return Amount</th>
                    <th class="tdCenter">Total Sale Amount</th>
                    <th class="tdCenter">Total Affiliate Share</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="success">
                      {{ soldPinList.length }}
                    </td>
                    <td class="danger">
                      {{ formatNumber(totalRetunAmount, 2) }}
                    </td>
                    <td class="warning">
                      {{ formatNumber(totalSoldAmount, 2) }}
                    </td>
                    <td class="info">
                      {{ formatNumber(totalAffiliateShare, 4) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import axios from "axios";
import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
  },
  name: "AffiliateSalesReport",
  data() {
    return {
      campaignArr: [],
      filterShortDateRange: [],
      couponArr: [],
      campaign_id: "",
      id_reseller: "",
      soldPinList: [],
      totalSoldAmount: 0,
      totalRetunAmount: 0,
      totalAffiliateShare: 0,
      // coupon_id: "",
      salesReportType: "1",
      // starttime: "",
      // stoptime: "",
      salesType: "",
    };
  },
  created() {
    this.com_user_type_access([1, 2], true);
    var encryptedData = this.$store.getters.getUser;
    var decodedString = this.com_DecryptString(encryptedData);
    var userData = JSON.parse(decodedString);
    this.id_reseller = userData.id_reseller;
    var baseUrl = window.location.pathname;
    var splittedUrl = baseUrl.split("/");
    var campaignId = splittedUrl[splittedUrl.length - 1];
    this.campaign_id = campaignId;
    this.userData = userData;
    if (userData.user_level == 1) {
      this.$router.push("dashboard");
    }
    this.getCampaignSalesReport();
  },
  methods: {
    getCampaignSalesReport() {
      var self = this;
      loader.show();
      var data = {
        id_reseller: this.id_reseller,
        campaign_id: this.campaign_id,
        // report_type: $("#report_type").val(),
        // short_filter: $("#short_filter").val(),
        // coupon_id: this.coupon_id,
        type: this.salesType,
      };
      axios
        .post("/affiliate/get-campaign-sales-report", data)
        .then(function (response) {
          if (response.data.result == "Success") {
            response = response.data;
            self.campaignArr = response.data.campaignList;
            self.filterShortDateRange = response.data.filterDropdownOptions;
            self.couponArr = response.data.couponArray;
            self.soldPinList = response.data.soldPinListData;
            self.calculateAmount();
            loader.hide();
          }
        })
        .catch(function (error) {
          loader.hide();
        });
    },
    calculateAmount() {
      var totalSoldAmount = 0;
      var totalReturnAmount = 0;
      var totalShareAmount = 0;
      var self = this;
      for (var i = 0; i < self.soldPinList.length; i++) {
        if (self.soldPinList[i].type == 1) {
          var tmpPrice = self.soldPinList[i].selling_price - 0;
          totalSoldAmount += tmpPrice;
        } else {
          var tmpPrice = self.soldPinList[i].selling_price - 0;
          totalReturnAmount += tmpPrice;
        }
        totalShareAmount +=
          (self.soldPinList[i].selling_price *
            self.couponArr[self.soldPinList[i].campaign_coupon_id]
              .affiliate_share_percent) /
          100;
      }
      self.totalSoldAmount = totalSoldAmount;
      self.totalRetunAmount = totalReturnAmount;
      self.totalAffiliateShare = totalShareAmount;
    },
    formatDate(date) {
      const options = {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      };
      return new Intl.DateTimeFormat("en-GB", options).format(new Date(date));
    },
    formatNumber(value, decimals) {
      return Number(value).toFixed(decimals);
    },
  },

  mounted: function () {
    this.getCampaignSalesReport();
    // $(".datePicker")
    //   .datetimepicker({
    //     timepicker: false,
    //     format: "Y-m-d",
    //     autoclose: true,
    //   })
    //   .on("change", function (e) {
    //     const inputId = $(this).attr("id");
    //     if (inputId === "starttime") {
    //       vm.formData.date_range.start = $(this).val();
    //     } else if (inputId === "stoptime") {
    //       vm.formData.date_range.end = $(this).val();
    //     }
    //   });
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
